import { Pencil } from "lucide-react";
import { Td } from "./common";
import { fmtMoney } from "../lib/api";

export const ASSET_COLUMNS = ["ID", "Asset Name", "Type", "Op Status", "Class", "Location", "Department", "Driver", "Make / Model", "Year", "VIN / Serial", "Orig. Cost", "Net Book Value", "Asset Status", ""];

export const AssetRow = ({ asset: a, setStatus, openEdit }) => (
  <tr className="hover:bg-slate-800/30 transition-colors duration-150" data-testid={`asset-row-${a.id}`}>
    <Td className="font-mono text-xs text-slate-500">{a.fixed_asset_id || "—"}</Td>
    <Td className="font-mono font-semibold text-amber-400">{a.asset_name}</Td>
    <Td className="capitalize">{a.asset_type?.replace("_", " ") || "—"}</Td>
    <Td><input data-testid={`asset-status-${a.id}`} defaultValue={a.operation_status || "active"} onBlur={(e) => {
      const value = e.target.value.trim();
      if (value && value !== (a.operation_status || "active")) setStatus(a, value);
    }} onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()} className="w-28 bg-slate-900/80 border border-slate-700 rounded-md px-2 py-1 text-xs text-slate-100 focus:outline-none focus:border-amber-500/60 transition-colors duration-200" /></Td>
    <Td>{a.asset_class || "—"}</Td>
    <Td className="max-w-[140px] truncate">{a.location || "—"}</Td>
    <Td>{a.department || "—"}</Td><Td>{a.driver_name || "—"}</Td>
    <Td>{[a.make, a.model].filter(Boolean).join(" ") || "—"}</Td><Td>{a.year_of_manufacturing || "—"}</Td>
    <Td className="font-mono text-xs text-slate-500">{a.vin_serial || "—"}</Td>
    <Td>{fmtMoney(a.original_cost)}</Td><Td className="text-emerald-400">{fmtMoney(a.current_net_book_value)}</Td>
    <Td className="capitalize">{(a.asset_status || "in_service").replace(/_/g, " ")}</Td>
    <Td><button data-testid={`asset-edit-${a.id}`} onClick={() => openEdit(a)} className="p-1.5 rounded text-slate-500 hover:text-amber-400 hover:bg-amber-500/10 transition-colors duration-200"><Pencil size={14} /></button></Td>
  </tr>
);
